module.exports = __webpack_public_path__ + "img/howto-install.153827e0.jpg";